import { useCallback } from 'react';

import { useStores } from '~store';
import { getAcceptableJobs } from '~utils/jobs/job-utils';

// Same predicate and view-only gate as AcceptAllJobsCTA, so the External tab accent shows
// exactly when Accept All does.
export default function useIsOrderAwaitingResponse() {
  const { ordersDispatchStore, userStore } = useStores();
  const { orderJobs } = ordersDispatchStore;
  const highlightsAwaitingResponse =
    ordersDispatchStore.filters.external === true && !userStore.isViewOnlyUser;

  return useCallback(
    (orderId: string) =>
      highlightsAwaitingResponse &&
      getAcceptableJobs(orderJobs.get(orderId) ?? []).length > 0,
    [highlightsAwaitingResponse, orderJobs],
  );
}
